import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { portinColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPortin } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "plan_id",
  "plan",
  "trial_count",
  "zipcode",
  "last_updated",
];

const PortinBatch = () => (
  <BatchDetail
    title="Portin"
    apiGet={__getPortin}
    client={CLIENTS.ultra}
    columnsFactory={portinColumns}
    copyKeys={COPY_KEYS}
    exportAction="portin"
    showTerminate
    getRowPath={(row) => `/ultra/portin/${row.id}`}
  />
);

export default PortinBatch;
